<template>
  <div class="form-element -nomargin">
    <form-select :title="'İl'" :message="cityMessage" :list="citiesData" v-model="city" />
    <form-select
      :title="'İlçe'"
      :message="districtMessage"
      :list="districtsData"
      :isPassive="!city"
      v-model="district"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    cityMessage: {
      type: String,
      default: null
    },
    districtMessage: {
      type: String,
      default: null
    },
    cities: {
      type: Array,
      default: () => []
    },
    districts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      citiesData: [],
      districtsData: [],
      city: this.value.city,
      district: this.value.district
    }
  },
  watch: {
    value: function (val) {
      this.city = val.city
      this.district = val.district
    },
    districts: function (val) {
      this.districtsData = val
    },
    city: function (val) {
      this.district = null

      let obj = {
        city: val,
        district: null
      }

      this.$emit('input', obj)

      if (this.cities.length > 0) return

      let city = this.citiesData.find((item) => item.name === val)
      this.districtsData = city.district
    },
    district: function (val) {
      if (!this.city && !this.district) return this.$emit('input', { city: null, district: null })

      let obj = {
        city: this.city,
        district: val
      }

      this.$emit('input', obj)
    }
  },
  created() {
    this.createDate()
  },
  methods: {
    createDate: function () {
      let vm = this

      if (vm.cities.length > 0) return (vm.citiesData = vm.cities)

      vm.citiesData = [
        {
          id: 1,
          name: 'Adana',
          district: [
            { id: 1, name: 'Aladağ' },
            { id: 2, name: 'Ceyhan' },
            { id: 3, name: 'Çukurova' },
            { id: 4, name: 'Feke' },
            { id: 5, name: 'İmamoğlu' },
            { id: 6, name: 'Karaisalı' },
            { id: 7, name: 'Karataş' },
            { id: 8, name: 'Kozan' },
            { id: 9, name: 'Pozantı' },
            { id: 10, name: 'Saimbeyli' },
            { id: 11, name: 'Sarıçam' },
            { id: 12, name: 'Seyhan' },
            { id: 13, name: 'Tufanbeyli' },
            { id: 14, name: 'Yumurtalık' },
            { id: 15, name: 'Yüreğir' }
          ]
        },
        {
          id: 2,
          name: 'Adıyaman',
          district: [
            { id: 1, name: 'Besni' },
            { id: 2, name: 'Çelikhan' },
            { id: 3, name: 'Gerger' },
            { id: 4, name: 'Gölbaşı' },
            { id: 5, name: 'Kahta' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Samsat' },
            { id: 8, name: 'Sincik' },
            { id: 9, name: 'Tut' }
          ]
        },
        {
          id: 3,
          name: 'Afyonkarahisar',
          district: [
            { id: 1, name: 'Başmakçı' },
            { id: 2, name: 'Bayat' },
            { id: 3, name: 'Bolvadin' },
            { id: 4, name: 'Çay' },
            { id: 5, name: 'Çobanlar' },
            { id: 6, name: 'Dazkırı' },
            { id: 7, name: 'Dinar' },
            { id: 8, name: 'Emirdağ' },
            { id: 9, name: 'Evciler' },
            { id: 10, name: 'Hocalar' },
            { id: 11, name: 'İhsaniye' },
            { id: 12, name: 'İscehisar' },
            { id: 13, name: 'Kızılören' },
            { id: 14, name: 'Merkez' },
            { id: 15, name: 'Sandıklı' },
            { id: 16, name: 'Sinanpaşa' },
            { id: 17, name: 'Sultandağı' },
            { id: 18, name: 'Şuhut' }
          ]
        },
        {
          id: 4,
          name: 'Ağrı',
          district: [
            { id: 1, name: 'Diyadin' },
            { id: 2, name: 'Doğubayazıt' },
            { id: 3, name: 'Eleşkirt' },
            { id: 4, name: 'Hamur' },
            { id: 5, name: 'Merkez' },
            { id: 6, name: 'Patnos' },
            { id: 7, name: 'Taşlıçay' },
            { id: 8, name: 'Tutak' }
          ]
        },
        {
          id: 5,
          name: 'Amasya',
          district: [
            { id: 1, name: 'Göynücek' },
            { id: 2, name: 'Gümüşhacıköy' },
            { id: 3, name: 'Hamamözü' },
            { id: 4, name: 'Merkez' },
            { id: 5, name: 'Merzifon' },
            { id: 6, name: 'Suluova' },
            { id: 7, name: 'Taşova' }
          ]
        },
        {
          id: 6,
          name: 'Ankara',
          district: [
            { id: 1, name: 'Altındağ' },
            { id: 2, name: 'Ayaş' },
            { id: 3, name: 'Bala' },
            { id: 4, name: 'Beypazarı' },
            { id: 5, name: 'Çamlıdere' },
            { id: 6, name: 'Çankaya' },
            { id: 7, name: 'Çubuk' },
            { id: 8, name: 'Elmadağ' },
            { id: 9, name: 'Güdül' },
            { id: 10, name: 'Haymana' },
            { id: 11, name: 'Kalecik' },
            { id: 12, name: 'Kızılcahamam' },
            { id: 13, name: 'Nallıhan' },
            { id: 14, name: 'Polatlı' },
            { id: 15, name: 'Şereflikoçhisar' },
            { id: 16, name: 'Yenimahalle' },
            { id: 17, name: 'Gölbaşı' },
            { id: 18, name: 'Keçiören' },
            { id: 19, name: 'Mamak' },
            { id: 20, name: 'Sincan' },
            { id: 21, name: 'Kazan' },
            { id: 22, name: 'Akyurt' },
            { id: 23, name: 'Etimesgut' },
            { id: 24, name: 'Evren' },
            { id: 25, name: 'Pursaklar' }
          ]
        },
        {
          id: 7,
          name: 'Antalya',
          district: [
            { id: 1, name: 'Akseki' },
            { id: 2, name: 'Alanya' },
            { id: 3, name: 'Elmalı' },
            { id: 4, name: 'Finike' },
            { id: 5, name: 'Gazipaşa' },
            { id: 6, name: 'Gündoğmuş' },
            { id: 7, name: 'Kaş' },
            { id: 8, name: 'Korkuteli' },
            { id: 9, name: 'Kumluca' },
            { id: 10, name: 'Manavgat' },
            { id: 11, name: 'Serik' },
            { id: 12, name: 'Demre' },
            { id: 13, name: 'İbradı' },
            { id: 14, name: 'Kemer' },
            { id: 15, name: 'Aksu' },
            { id: 16, name: 'Döşemealtı' },
            { id: 17, name: 'Kepez' },
            { id: 18, name: 'Konyaaltı' },
            { id: 19, name: 'Muratpaşa' }
          ]
        },
        {
          id: 8,
          name: 'Artvin',
          district: [
            { id: 1, name: 'Ardanuç' },
            { id: 2, name: 'Arhavi' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Borçka' },
            { id: 5, name: 'Hopa' },
            { id: 6, name: 'Şavşat' },
            { id: 7, name: 'Yusufeli' },
            { id: 8, name: 'Murgul' }
          ]
        },
        {
          id: 9,
          name: 'Aydın',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Bozdoğan' },
            { id: 3, name: 'Efeler' },
            { id: 4, name: 'Çine' },
            { id: 5, name: 'Germencik' },
            { id: 6, name: 'Karacasu' },
            { id: 7, name: 'Koçarlı' },
            { id: 8, name: 'Kuşadası' },
            { id: 9, name: 'Kuyucak' },
            { id: 10, name: 'Nazilli' },
            { id: 11, name: 'Söke' },
            { id: 12, name: 'Sultanhisar' },
            { id: 13, name: 'Yenipazar' },
            { id: 14, name: 'Buharkent' },
            { id: 15, name: 'İncirliova' },
            { id: 16, name: 'Karpuzlu' },
            { id: 17, name: 'Köşk' },
            { id: 18, name: 'Didim' }
          ]
        },
        {
          id: 10,
          name: 'Balıkesir',
          district: [
            { id: 1, name: 'Altıeylül' },
            { id: 2, name: 'Ayvalık' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Balya' },
            { id: 5, name: 'Bandırma' },
            { id: 6, name: 'Bigadiç' },
            { id: 7, name: 'Burhaniye' },
            { id: 8, name: 'Dursunbey' },
            { id: 9, name: 'Edremit' },
            { id: 10, name: 'Erdek' },
            { id: 11, name: 'Gönen' },
            { id: 12, name: 'Havran' },
            { id: 13, name: 'İvrindi' },
            { id: 14, name: 'Karesi' },
            { id: 15, name: 'Kepsut' },
            { id: 16, name: 'Manyas' },
            { id: 17, name: 'Savaştepe' },
            { id: 18, name: 'Sındırgı' },
            { id: 19, name: 'Gömeç' },
            { id: 20, name: 'Susurluk' },
            { id: 21, name: 'Marmara' }
          ]
        },
        {
          id: 11,
          name: 'Bilecik',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Bozüyük' },
            { id: 3, name: 'Gölpazarı' },
            { id: 4, name: 'Osmaneli' },
            { id: 5, name: 'Pazaryeri' },
            { id: 6, name: 'Söğüt' },
            { id: 7, name: 'Yenipazar' },
            { id: 8, name: 'İnhisar' }
          ]
        },
        {
          id: 12,
          name: 'Bingöl',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Genç' },
            { id: 3, name: 'Karlıova' },
            { id: 4, name: 'Kiğı' },
            { id: 5, name: 'Solhan' },
            { id: 6, name: 'Adaklı' },
            { id: 7, name: 'Yayladere' },
            { id: 8, name: 'Yedisu' }
          ]
        },
        {
          id: 13,
          name: 'Bitlis',
          district: [
            { id: 1, name: 'Adilcevaz' },
            { id: 2, name: 'Ahlat' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Hizan' },
            { id: 5, name: 'Mutki' },
            { id: 6, name: 'Tatvan' },
            { id: 7, name: 'Güroymak' }
          ]
        },
        {
          id: 14,
          name: 'Bolu',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Gerede' },
            { id: 3, name: 'Göynük' },
            { id: 4, name: 'Kıbrıscık' },
            { id: 5, name: 'Mengen' },
            { id: 6, name: 'Mudurnu' },
            { id: 7, name: 'Seben' },
            { id: 8, name: 'Dörtdivan' },
            { id: 9, name: 'Yeniçağa' }
          ]
        },
        {
          id: 15,
          name: 'Burdur',
          district: [
            { id: 1, name: 'Ağlasun' },
            { id: 2, name: 'Bucak' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Gölhisar' },
            { id: 5, name: 'Tefenni' },
            { id: 6, name: 'Yeşilova' },
            { id: 7, name: 'Karamanlı' },
            { id: 8, name: 'Kemer' },
            { id: 9, name: 'Altınyayla' },
            { id: 10, name: 'Çavdır' },
            { id: 11, name: 'Çeltikçi' }
          ]
        },
        {
          id: 16,
          name: 'Bursa',
          district: [
            { id: 1, name: 'Gemlik' },
            { id: 2, name: 'İnegöl' },
            { id: 3, name: 'İznik' },
            { id: 4, name: 'Karacabey' },
            { id: 5, name: 'Keles' },
            { id: 6, name: 'Mudanya' },
            { id: 7, name: 'Mustafakemalpaşa' },
            { id: 8, name: 'Orhaneli' },
            { id: 9, name: 'Orhangazi' },
            { id: 10, name: 'Yenişehir' },
            { id: 11, name: 'Büyükorhan' },
            { id: 12, name: 'Harmancık' },
            { id: 13, name: 'Nilüfer' },
            { id: 14, name: 'Osmangazi' },
            { id: 15, name: 'Yıldırım' },
            { id: 16, name: 'Gürsu' },
            { id: 17, name: 'Kestel' }
          ]
        },
        {
          id: 17,
          name: 'Çanakkale',
          district: [
            { id: 1, name: 'Ayvacık' },
            { id: 2, name: 'Bayramiç' },
            { id: 3, name: 'Biga' },
            { id: 4, name: 'Bozcaada' },
            { id: 5, name: 'Çan' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Eceabat' },
            { id: 8, name: 'Ezine' },
            { id: 9, name: 'Gelibolu' },
            { id: 10, name: 'Gökçeada' },
            { id: 11, name: 'Lapseki' },
            { id: 12, name: 'Yenice' }
          ]
        },
        {
          id: 18,
          name: 'Çankırı',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Çerkeş' },
            { id: 3, name: 'Eldivan' },
            { id: 4, name: 'Ilgaz' },
            { id: 5, name: 'Kurşunlu' },
            { id: 6, name: 'Orta' },
            { id: 7, name: 'Şabanözü' },
            { id: 8, name: 'Yapraklı' },
            { id: 9, name: 'Atkaracalar' },
            { id: 10, name: 'Kızılırmak' },
            { id: 11, name: 'Bayramören' },
            { id: 12, name: 'Korgun' }
          ]
        },
        {
          id: 19,
          name: 'Çorum',
          district: [
            { id: 1, name: 'Alaca' },
            { id: 2, name: 'Bayat' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'İskilip' },
            { id: 5, name: 'Kargı' },
            { id: 6, name: 'Mecitözü' },
            { id: 7, name: 'Ortaköy' },
            { id: 8, name: 'Osmancık' },
            { id: 9, name: 'Sungurlu' },
            { id: 10, name: 'Boğazkale' },
            { id: 11, name: 'Uğurludağ' },
            { id: 12, name: 'Dodurga' },
            { id: 13, name: 'Laçin' },
            { id: 14, name: 'Oğuzlar' }
          ]
        },
        {
          id: 20,
          name: 'Denizli',
          district: [
            { id: 1, name: 'Acıpayam' },
            { id: 2, name: 'Buldan' },
            { id: 3, name: 'Çal' },
            { id: 4, name: 'Çameli' },
            { id: 5, name: 'Çardak' },
            { id: 6, name: 'Çivril' },
            { id: 7, name: 'Merkez' },
            { id: 8, name: 'Merkezefendi' },
            { id: 9, name: 'Pamukkale' },
            { id: 10, name: 'Güney' },
            { id: 11, name: 'Kale' },
            { id: 12, name: 'Sarayköy' },
            { id: 13, name: 'Tavas' },
            { id: 14, name: 'Babadağ' },
            { id: 15, name: 'Bekilli' },
            { id: 16, name: 'Honaz' },
            { id: 17, name: 'Serinhisar' },
            { id: 18, name: 'Baklan' },
            { id: 19, name: 'Beyağaç' },
            { id: 20, name: 'Bozkurt' }
          ]
        },
        {
          id: 21,
          name: 'Diyarbakır',
          district: [
            { id: 1, name: 'Kocaköy' },
            { id: 2, name: 'Çermik' },
            { id: 3, name: 'Çınar' },
            { id: 4, name: 'Çüngüş' },
            { id: 5, name: 'Dicle' },
            { id: 6, name: 'Ergani' },
            { id: 7, name: 'Hani' },
            { id: 8, name: 'Hazro' },
            { id: 9, name: 'Kulp' },
            { id: 10, name: 'Lice' },
            { id: 11, name: 'Silvan' },
            { id: 12, name: 'Eğil' },
            { id: 13, name: 'Bağlar' },
            { id: 14, name: 'Kayapınar' },
            { id: 15, name: 'Sur' },
            { id: 16, name: 'Yenişehir' },
            { id: 17, name: 'Bismil' }
          ]
        },
        {
          id: 22,
          name: 'Edirne',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Enez' },
            { id: 3, name: 'Havsa' },
            { id: 4, name: 'İpsala' },
            { id: 5, name: 'Keşan' },
            { id: 6, name: 'Lalapaşa' },
            { id: 7, name: 'Meriç' },
            { id: 8, name: 'Uzunköprü' },
            { id: 9, name: 'Süloğlu' }
          ]
        },
        {
          id: 23,
          name: 'Elazığ',
          district: [
            { id: 1, name: 'Ağın' },
            { id: 2, name: 'Baskil' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Karakoçan' },
            { id: 5, name: 'Keban' },
            { id: 6, name: 'Maden' },
            { id: 7, name: 'Palu' },
            { id: 8, name: 'Sivrice' },
            { id: 9, name: 'Arıcak' },
            { id: 10, name: 'Kovancılar' },
            { id: 11, name: 'Alacakaya' }
          ]
        },
        {
          id: 24,
          name: 'Erzincan',
          district: [
            { id: 1, name: 'Çayırlı' },
            { id: 2, name: 'Merkez' },
            { id: 3, name: 'İliç' },
            { id: 4, name: 'Kemah' },
            { id: 5, name: 'Kemaliye' },
            { id: 6, name: 'Refahiye' },
            { id: 7, name: 'Tercan' },
            { id: 8, name: 'Üzümlü' },
            { id: 9, name: 'Otlukbeli' }
          ]
        },
        {
          id: 25,
          name: 'Erzurum',
          district: [
            { id: 1, name: 'Aşkale' },
            { id: 2, name: 'Çat' },
            { id: 3, name: 'Hınıs' },
            { id: 4, name: 'Horasan' },
            { id: 5, name: 'İspir' },
            { id: 6, name: 'Karayazı' },
            { id: 7, name: 'Narman' },
            { id: 8, name: 'Oltu' },
            { id: 9, name: 'Olur' },
            { id: 10, name: 'Pasinler' },
            { id: 11, name: 'Şenkaya' },
            { id: 12, name: 'Tekman' },
            { id: 13, name: 'Tortum' },
            { id: 14, name: 'Karaçoban' },
            { id: 15, name: 'Uzundere' },
            { id: 16, name: 'Pazaryolu' },
            { id: 17, name: 'Köprüköy' },
            { id: 18, name: 'Palandöken' },
            { id: 19, name: 'Yakutiye' },
            { id: 20, name: 'Aziziye' }
          ]
        },
        {
          id: 26,
          name: 'Eskişehir',
          district: [
            { id: 1, name: 'Çifteler' },
            { id: 2, name: 'Mahmudiye' },
            { id: 3, name: 'Mihalıççık' },
            { id: 4, name: 'Sarıcakaya' },
            { id: 5, name: 'Seyitgazi' },
            { id: 6, name: 'Sivrihisar' },
            { id: 7, name: 'Alpu' },
            { id: 8, name: 'Beylikova' },
            { id: 9, name: 'İnönü' },
            { id: 10, name: 'Günyüzü' },
            { id: 11, name: 'Han' },
            { id: 12, name: 'Mihalgazi' },
            { id: 13, name: 'Odunpazarı' },
            { id: 14, name: 'Tepebaşı' }
          ]
        },
        {
          id: 27,
          name: 'Gaziantep',
          district: [
            { id: 1, name: 'Araban' },
            { id: 2, name: 'İslahiye' },
            { id: 3, name: 'Nizip' },
            { id: 4, name: 'Oğuzeli' },
            { id: 5, name: 'Yavuzeli' },
            { id: 6, name: 'Şahinbey' },
            { id: 7, name: 'Şehitkamil' },
            { id: 8, name: 'Karkamış' },
            { id: 9, name: 'Nurdağı' }
          ]
        },
        {
          id: 28,
          name: 'Giresun',
          district: [
            { id: 1, name: 'Alucra' },
            { id: 2, name: 'Bulancak' },
            { id: 3, name: 'Dereli' },
            { id: 4, name: 'Espiye' },
            { id: 5, name: 'Eynesil' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Görele' },
            { id: 8, name: 'Keşap' },
            { id: 9, name: 'Şebinkarahisar' },
            { id: 10, name: 'Tirebolu' },
            { id: 11, name: 'Piraziz' },
            { id: 12, name: 'Yağlıdere' },
            { id: 13, name: 'Çamoluk' },
            { id: 14, name: 'Çanakçı' },
            { id: 15, name: 'Doğankent' },
            { id: 16, name: 'Güce' }
          ]
        },
        {
          id: 29,
          name: 'Gümüşhane',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Kelkit' },
            { id: 3, name: 'Şiran' },
            { id: 4, name: 'Torul' },
            { id: 5, name: 'Köse' },
            { id: 6, name: 'Kürtün' }
          ]
        },
        {
          id: 30,
          name: 'Hakkari',
          district: [
            { id: 1, name: 'Çukurca' },
            { id: 2, name: 'Merkez' },
            { id: 3, name: 'Şemdinli' },
            { id: 4, name: 'Yüksekova' }
          ]
        },
        {
          id: 31,
          name: 'Hatay',
          district: [
            { id: 1, name: 'Altınözü' },
            { id: 2, name: 'Arsuz' },
            { id: 3, name: 'Defne' },
            { id: 4, name: 'Dörtyol' },
            { id: 5, name: 'Hassa' },
            { id: 6, name: 'Antakya' },
            { id: 7, name: 'İskenderun' },
            { id: 8, name: 'Kırıkhan' },
            { id: 9, name: 'Payas' },
            { id: 10, name: 'Reyhanlı' },
            { id: 11, name: 'Samandağ' },
            { id: 12, name: 'Yayladağı' },
            { id: 13, name: 'Erzin' },
            { id: 14, name: 'Belen' },
            { id: 15, name: 'Kumlu' }
          ]
        },
        {
          id: 32,
          name: 'Isparta',
          district: [
            { id: 1, name: 'Atabey' },
            { id: 2, name: 'Eğirdir' },
            { id: 3, name: 'Gelendost' },
            { id: 4, name: 'Merkez' },
            { id: 5, name: 'Keçiborlu' },
            { id: 6, name: 'Senirkent' },
            { id: 7, name: 'Sütçüler' },
            { id: 8, name: 'Şarkikaraağaç' },
            { id: 9, name: 'Uluborlu' },
            { id: 10, name: 'Yalvaç' },
            { id: 11, name: 'Aksu' },
            { id: 12, name: 'Gönen' },
            { id: 13, name: 'Yenişarbademli' }
          ]
        },
        {
          id: 33,
          name: 'Mersin',
          district: [
            { id: 1, name: 'Anamur' },
            { id: 2, name: 'Erdemli' },
            { id: 3, name: 'Gülnar' },
            { id: 4, name: 'Mut' },
            { id: 5, name: 'Silifke' },
            { id: 6, name: 'Tarsus' },
            { id: 7, name: 'Aydıncık' },
            { id: 8, name: 'Bozyazı' },
            { id: 9, name: 'Çamlıyayla' },
            { id: 10, name: 'Akdeniz' },
            { id: 11, name: 'Mezitli' },
            { id: 12, name: 'Toroslar' },
            { id: 13, name: 'Yenişehir' }
          ]
        },
        {
          id: 34,
          name: 'İstanbul',
          district: [
            { id: 1, name: 'Adalar' },
            { id: 2, name: 'Bakırköy' },
            { id: 3, name: 'Beşiktaş' },
            { id: 4, name: 'Beykoz' },
            { id: 5, name: 'Beyoğlu' },
            { id: 6, name: 'Çatalca' },
            { id: 7, name: 'Eyüp' },
            { id: 8, name: 'Fatih' },
            { id: 9, name: 'Gaziosmanpaşa' },
            { id: 10, name: 'Kadıköy' },
            { id: 11, name: 'Kartal' },
            { id: 12, name: 'Sarıyer' },
            { id: 13, name: 'Silivri' },
            { id: 14, name: 'Şile' },
            { id: 15, name: 'Şişli' },
            { id: 16, name: 'Üsküdar' },
            { id: 17, name: 'Zeytinburnu' },
            { id: 18, name: 'Büyükçekmece' },
            { id: 19, name: 'Kağıthane' },
            { id: 20, name: 'Küçükçekmece' },
            { id: 21, name: 'Pendik' },
            { id: 22, name: 'Ümraniye' },
            { id: 23, name: 'Bayrampaşa' },
            { id: 24, name: 'Avcılar' },
            { id: 25, name: 'Bağcılar' },
            { id: 26, name: 'Bahçelievler' },
            { id: 27, name: 'Güngören' },
            { id: 28, name: 'Maltepe' },
            { id: 29, name: 'Sultanbeyli' },
            { id: 30, name: 'Tuzla' },
            { id: 31, name: 'Esenler' },
            { id: 32, name: 'Arnavutköy' },
            { id: 33, name: 'Ataşehir' },
            { id: 34, name: 'Başakşehir' },
            { id: 35, name: 'Beylikdüzü' },
            { id: 36, name: 'Çekmeköy' },
            { id: 37, name: 'Esenyurt' },
            { id: 38, name: 'Sancaktepe' },
            { id: 39, name: 'Sultangazi' }
          ]
        },
        {
          id: 35,
          name: 'İzmir',
          district: [
            { id: 1, name: 'Aliağa' },
            { id: 2, name: 'Bayındır' },
            { id: 3, name: 'Bergama' },
            { id: 4, name: 'Bornova' },
            { id: 5, name: 'Çeşme' },
            { id: 6, name: 'Dikili' },
            { id: 7, name: 'Foça' },
            { id: 8, name: 'Karaburun' },
            { id: 9, name: 'Karşıyaka' },
            { id: 10, name: 'Kemalpaşa' },
            { id: 11, name: 'Kınık' },
            { id: 12, name: 'Kiraz' },
            { id: 13, name: 'Menemen' },
            { id: 14, name: 'Ödemiş' },
            { id: 15, name: 'Seferihisar' },
            { id: 16, name: 'Selçuk' },
            { id: 17, name: 'Tire' },
            { id: 18, name: 'Torbalı' },
            { id: 19, name: 'Urla' },
            { id: 20, name: 'Beydağ' },
            { id: 21, name: 'Buca' },
            { id: 22, name: 'Konak' },
            { id: 23, name: 'Menderes' },
            { id: 24, name: 'Balçova' },
            { id: 25, name: 'Çiğli' },
            { id: 26, name: 'Gaziemir' },
            { id: 27, name: 'Narlıdere' },
            { id: 28, name: 'Güzelbahçe' },
            { id: 29, name: 'Bayraklı' },
            { id: 30, name: 'Karabağlar' }
          ]
        },
        {
          id: 36,
          name: 'Kars',
          district: [
            { id: 1, name: 'Arpaçay' },
            { id: 2, name: 'Digor' },
            { id: 3, name: 'Kağızman' },
            { id: 4, name: 'Merkez' },
            { id: 5, name: 'Sarıkamış' },
            { id: 6, name: 'Selim' },
            { id: 7, name: 'Susuz' },
            { id: 8, name: 'Akyaka' }
          ]
        },
        {
          id: 37,
          name: 'Kastamonu',
          district: [
            { id: 1, name: 'Abana' },
            { id: 2, name: 'Araç' },
            { id: 3, name: 'Azdavay' },
            { id: 4, name: 'Bozkurt' },
            { id: 5, name: 'Cide' },
            { id: 6, name: 'Çatalzeytin' },
            { id: 7, name: 'Daday' },
            { id: 8, name: 'Devrekani' },
            { id: 9, name: 'İnebolu' },
            { id: 10, name: 'Merkez' },
            { id: 11, name: 'Küre' },
            { id: 12, name: 'Taşköprü' },
            { id: 13, name: 'Tosya' },
            { id: 14, name: 'İhsangazi' },
            { id: 15, name: 'Pınarbaşı' },
            { id: 16, name: 'Şenpazar' },
            { id: 17, name: 'Ağlı' },
            { id: 18, name: 'Doğanyurt' },
            { id: 19, name: 'Hanönü' },
            { id: 20, name: 'Seydiler' }
          ]
        },
        {
          id: 38,
          name: 'Kayseri',
          district: [
            { id: 1, name: 'Bünyan' },
            { id: 2, name: 'Develi' },
            { id: 3, name: 'Felahiye' },
            { id: 4, name: 'İncesu' },
            { id: 5, name: 'Pınarbaşı' },
            { id: 6, name: 'Sarıoğlan' },
            { id: 7, name: 'Sarız' },
            { id: 8, name: 'Tomarza' },
            { id: 9, name: 'Yahyalı' },
            { id: 10, name: 'Yeşilhisar' },
            { id: 11, name: 'Akkışla' },
            { id: 12, name: 'Talas' },
            { id: 13, name: 'Kocasinan' },
            { id: 14, name: 'Melikgazi' },
            { id: 15, name: 'Hacılar' },
            { id: 16, name: 'Özvatan' }
          ]
        },
        {
          id: 39,
          name: 'Kırklareli',
          district: [
            { id: 1, name: 'Babaeski' },
            { id: 2, name: 'Demirköy' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Kofçaz' },
            { id: 5, name: 'Lüleburgaz' },
            { id: 6, name: 'Pehlivanköy' },
            { id: 7, name: 'Pınarhisar' },
            { id: 8, name: 'Vize' }
          ]
        },
        {
          id: 40,
          name: 'Kırşehir',
          district: [
            { id: 1, name: 'Çiçekdağı' },
            { id: 2, name: 'Kaman' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Mucur' },
            { id: 5, name: 'Akpınar' },
            { id: 6, name: 'Akçakent' },
            { id: 7, name: 'Boztepe' }
          ]
        },
        {
          id: 41,
          name: 'Kocaeli',
          district: [
            { id: 1, name: 'Gebze' },
            { id: 2, name: 'Gölcük' },
            { id: 3, name: 'Kandıra' },
            { id: 4, name: 'Karamürsel' },
            { id: 5, name: 'Körfez' },
            { id: 6, name: 'Derince' },
            { id: 7, name: 'Başiskele' },
            { id: 8, name: 'Çayırova' },
            { id: 9, name: 'Darıca' },
            { id: 10, name: 'Dilovası' },
            { id: 11, name: 'İzmit' },
            { id: 12, name: 'Kartepe' }
          ]
        },
        {
          id: 42,
          name: 'Konya',
          district: [
            { id: 1, name: 'Akşehir' },
            { id: 2, name: 'Beyşehir' },
            { id: 3, name: 'Bozkır' },
            { id: 4, name: 'Cihanbeyli' },
            { id: 5, name: 'Çumra' },
            { id: 6, name: 'Doğanhisar' },
            { id: 7, name: 'Ereğli' },
            { id: 8, name: 'Hadim' },
            { id: 9, name: 'Ilgın' },
            { id: 10, name: 'Kadınhanı' },
            { id: 11, name: 'Karapınar' },
            { id: 12, name: 'Kulu' },
            { id: 13, name: 'Sarayönü' },
            { id: 14, name: 'Seydişehir' },
            { id: 15, name: 'Yunak' },
            { id: 16, name: 'Akören' },
            { id: 17, name: 'Altınekin' },
            { id: 18, name: 'Derebucak' },
            { id: 19, name: 'Hüyük' },
            { id: 20, name: 'Karatay' },
            { id: 21, name: 'Meram' },
            { id: 22, name: 'Selçuklu' },
            { id: 23, name: 'Taşkent' },
            { id: 24, name: 'Ahırlı' },
            { id: 25, name: 'Çeltik' },
            { id: 26, name: 'Derbent' },
            { id: 27, name: 'Emirgazi' },
            { id: 28, name: 'Güneysınır' },
            { id: 29, name: 'Halkapınar' },
            { id: 30, name: 'Tuzlukçu' },
            { id: 31, name: 'Yalıhüyük' }
          ]
        },
        {
          id: 43,
          name: 'Kütahya',
          district: [
            { id: 1, name: 'Altıntaş' },
            { id: 2, name: 'Domaniç' },
            { id: 3, name: 'Emet' },
            { id: 4, name: 'Gediz' },
            { id: 5, name: 'Merkez' },
            { id: 6, name: 'Simav' },
            { id: 7, name: 'Tavşanlı' },
            { id: 8, name: 'Aslanapa' },
            { id: 9, name: 'Dumlupınar' },
            { id: 10, name: 'Hisarcık' },
            { id: 11, name: 'Şaphane' },
            { id: 12, name: 'Çavdarhisar' },
            { id: 13, name: 'Pazarlar' }
          ]
        },
        {
          id: 44,
          name: 'Malatya',
          district: [
            { id: 1, name: 'Akçadağ' },
            { id: 2, name: 'Arapgir' },
            { id: 3, name: 'Arguvan' },
            { id: 4, name: 'Darende' },
            { id: 5, name: 'Doğanşehir' },
            { id: 6, name: 'Hekimhan' },
            { id: 7, name: 'Merkez' },
            { id: 8, name: 'Pütürge' },
            { id: 9, name: 'Yeşilyurt' },
            { id: 10, name: 'Battalgazi' },
            { id: 11, name: 'Doğanyol' },
            { id: 12, name: 'Kale' },
            { id: 13, name: 'Kuluncak' },
            { id: 14, name: 'Yazıhan' }
          ]
        },
        {
          id: 45,
          name: 'Manisa',
          district: [
            { id: 1, name: 'Akhisar' },
            { id: 2, name: 'Alaşehir' },
            { id: 3, name: 'Demirci' },
            { id: 4, name: 'Gördes' },
            { id: 5, name: 'Kırkağaç' },
            { id: 6, name: 'Kula' },
            { id: 7, name: 'Merkez' },
            { id: 8, name: 'Salihli' },
            { id: 9, name: 'Sarıgöl' },
            { id: 10, name: 'Saruhanlı' },
            { id: 11, name: 'Selendi' },
            { id: 12, name: 'Soma' },
            { id: 13, name: 'Şehzadeler' },
            { id: 14, name: 'Yunusemre' },
            { id: 15, name: 'Turgutlu' },
            { id: 16, name: 'Ahmetli' },
            { id: 17, name: 'Gölmarmara' },
            { id: 18, name: 'Köprübaşı' }
          ]
        },
        {
          id: 46,
          name: 'Kahramanmaraş',
          district: [
            { id: 1, name: 'Afşin' },
            { id: 2, name: 'Andırın' },
            { id: 3, name: 'Dulkadiroğlu' },
            { id: 4, name: 'Onikişubat' },
            { id: 5, name: 'Elbistan' },
            { id: 6, name: 'Göksun' },
            { id: 7, name: 'Merkez' },
            { id: 8, name: 'Pazarcık' },
            { id: 9, name: 'Türkoğlu' },
            { id: 10, name: 'Çağlayancerit' },
            { id: 11, name: 'Ekinözü' },
            { id: 12, name: 'Nurhak' }
          ]
        },
        {
          id: 47,
          name: 'Mardin',
          district: [
            { id: 1, name: 'Derik' },
            { id: 2, name: 'Kızıltepe' },
            { id: 3, name: 'Artuklu' },
            { id: 4, name: 'Merkez' },
            { id: 5, name: 'Mazıdağı' },
            { id: 6, name: 'Midyat' },
            { id: 7, name: 'Nusaybin' },
            { id: 8, name: 'Ömerli' },
            { id: 9, name: 'Savur' },
            { id: 10, name: 'Dargeçit' },
            { id: 11, name: 'Yeşilli' }
          ]
        },
        {
          id: 48,
          name: 'Muğla',
          district: [
            { id: 1, name: 'Bodrum' },
            { id: 2, name: 'Datça' },
            { id: 3, name: 'Fethiye' },
            { id: 4, name: 'Köyceğiz' },
            { id: 5, name: 'Marmaris' },
            { id: 6, name: 'Menteşe' },
            { id: 7, name: 'Milas' },
            { id: 8, name: 'Ula' },
            { id: 9, name: 'Yatağan' },
            { id: 10, name: 'Dalaman' },
            { id: 11, name: 'Seydikemer' },
            { id: 12, name: 'Ortaca' },
            { id: 13, name: 'Kavaklıdere' }
          ]
        },
        {
          id: 49,
          name: 'Muş',
          district: [
            { id: 1, name: 'Bulanık' },
            { id: 2, name: 'Malazgirt' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Varto' },
            { id: 5, name: 'Hasköy' },
            { id: 6, name: 'Korkut' }
          ]
        },
        {
          id: 50,
          name: 'Nevşehir',
          district: [
            { id: 1, name: 'Avanos' },
            { id: 2, name: 'Derinkuyu' },
            { id: 3, name: 'Gülşehir' },
            { id: 4, name: 'Hacıbektaş' },
            { id: 5, name: 'Kozaklı' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Ürgüp' },
            { id: 8, name: 'Acıgöl' }
          ]
        },
        {
          id: 51,
          name: 'Niğde',
          district: [
            { id: 1, name: 'Bor' },
            { id: 2, name: 'Çamardı' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Ulukışla' },
            { id: 5, name: 'Altunhisar' },
            { id: 6, name: 'Çiftlik' }
          ]
        },
        {
          id: 52,
          name: 'Ordu',
          district: [
            { id: 1, name: 'Akkuş' },
            { id: 2, name: 'Altınordu' },
            { id: 3, name: 'Aybastı' },
            { id: 4, name: 'Fatsa' },
            { id: 5, name: 'Gölköy' },
            { id: 6, name: 'Korgan' },
            { id: 7, name: 'Kumru' },
            { id: 8, name: 'Mesudiye' },
            { id: 9, name: 'Perşembe' },
            { id: 10, name: 'Ulubey' },
            { id: 11, name: 'Ünye' },
            { id: 12, name: 'Gülyalı' },
            { id: 13, name: 'Gürgentepe' },
            { id: 14, name: 'Çamaş' },
            { id: 15, name: 'Çatalpınar' },
            { id: 16, name: 'Çaybaşı' },
            { id: 17, name: 'İkizce' },
            { id: 18, name: 'Kabadüz' },
            { id: 19, name: 'Kabataş' }
          ]
        },
        {
          id: 53,
          name: 'Rize',
          district: [
            { id: 1, name: 'Ardeşen' },
            { id: 2, name: 'Çamlıhemşin' },
            { id: 3, name: 'Çayeli' },
            { id: 4, name: 'Fındıklı' },
            { id: 5, name: 'İkizdere' },
            { id: 6, name: 'Kalkandere' },
            { id: 7, name: 'Pazar' },
            { id: 8, name: 'Merkez' },
            { id: 9, name: 'Güneysu' },
            { id: 10, name: 'Derepazarı' },
            { id: 11, name: 'Hemşin' },
            { id: 12, name: 'İyidere' }
          ]
        },
        {
          id: 54,
          name: 'Sakarya',
          district: [
            { id: 1, name: 'Akyazı' },
            { id: 2, name: 'Geyve' },
            { id: 3, name: 'Hendek' },
            { id: 4, name: 'Karasu' },
            { id: 5, name: 'Kaynarca' },
            { id: 6, name: 'Sapanca' },
            { id: 7, name: 'Kocaali' },
            { id: 8, name: 'Pamukova' },
            { id: 9, name: 'Taraklı' },
            { id: 10, name: 'Ferizli' },
            { id: 11, name: 'Karapürçek' },
            { id: 12, name: 'Söğütlü' },
            { id: 13, name: 'Adapazarı' },
            { id: 14, name: 'Arifiye' },
            { id: 15, name: 'Erenler' },
            { id: 16, name: 'Serdivan' }
          ]
        },
        {
          id: 55,
          name: 'Samsun',
          district: [
            { id: 1, name: 'Alaçam' },
            { id: 2, name: 'Bafra' },
            { id: 3, name: 'Çarşamba' },
            { id: 4, name: 'Havza' },
            { id: 5, name: 'Kavak' },
            { id: 6, name: 'Ladik' },
            { id: 7, name: 'Terme' },
            { id: 8, name: 'Vezirköprü' },
            { id: 9, name: 'Asarcık' },
            { id: 10, name: 'Ondokuzmayıs' },
            { id: 11, name: 'Salıpazarı' },
            { id: 12, name: 'Tekkeköy' },
            { id: 13, name: 'Ayvacık' },
            { id: 14, name: 'Yakakent' },
            { id: 15, name: 'Atakum' },
            { id: 16, name: 'Canik' },
            { id: 17, name: 'İlkadım' }
          ]
        },
        {
          id: 56,
          name: 'Siirt',
          district: [
            { id: 1, name: 'Baykan' },
            { id: 2, name: 'Eruh' },
            { id: 3, name: 'Kurtalan' },
            { id: 4, name: 'Pervari' },
            { id: 5, name: 'Merkez' },
            { id: 6, name: 'Şirvan' },
            { id: 7, name: 'Tillo' }
          ]
        },
        {
          id: 57,
          name: 'Sinop',
          district: [
            { id: 1, name: 'Ayancık' },
            { id: 2, name: 'Boyabat' },
            { id: 3, name: 'Durağan' },
            { id: 4, name: 'Erfelek' },
            { id: 5, name: 'Gerze' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Türkeli' },
            { id: 8, name: 'Dikmen' },
            { id: 9, name: 'Saraydüzü' }
          ]
        },
        {
          id: 58,
          name: 'Sivas',
          district: [
            { id: 1, name: 'Divriği' },
            { id: 2, name: 'Gemerek' },
            { id: 3, name: 'Gürün' },
            { id: 4, name: 'Hafik' },
            { id: 5, name: 'İmranlı' },
            { id: 6, name: 'Kangal' },
            { id: 7, name: 'Koyulhisar' },
            { id: 8, name: 'Merkez' },
            { id: 9, name: 'Suşehri' },
            { id: 10, name: 'Şarkışla' },
            { id: 11, name: 'Yıldızeli' },
            { id: 12, name: 'Zara' },
            { id: 13, name: 'Akıncılar' },
            { id: 14, name: 'Altınyayla' },
            { id: 15, name: 'Doğanşar' },
            { id: 16, name: 'Gölova' },
            { id: 17, name: 'Ulaş' }
          ]
        },
        {
          id: 59,
          name: 'Tekirdağ',
          district: [
            { id: 1, name: 'Çerkezköy' },
            { id: 2, name: 'Çorlu' },
            { id: 3, name: 'Ergene' },
            { id: 4, name: 'Hayrabolu' },
            { id: 5, name: 'Malkara' },
            { id: 6, name: 'Muratlı' },
            { id: 7, name: 'Saray' },
            { id: 8, name: 'Süleymanpaşa' },
            { id: 9, name: 'Kapaklı' },
            { id: 10, name: 'Şarköy' },
            { id: 11, name: 'Marmaraereğlisi' }
          ]
        },
        {
          id: 60,
          name: 'Tokat',
          district: [
            { id: 1, name: 'Almus' },
            { id: 2, name: 'Artova' },
            { id: 3, name: 'Erbaa' },
            { id: 4, name: 'Niksar' },
            { id: 5, name: 'Reşadiye' },
            { id: 6, name: 'Merkez' },
            { id: 7, name: 'Turhal' },
            { id: 8, name: 'Zile' },
            { id: 9, name: 'Pazar' },
            { id: 10, name: 'Yeşilyurt' },
            { id: 11, name: 'Başçiftlik' },
            { id: 12, name: 'Sulusaray' }
          ]
        },
        {
          id: 61,
          name: 'Trabzon',
          district: [
            { id: 1, name: 'Akçaabat' },
            { id: 2, name: 'Araklı' },
            { id: 3, name: 'Arsin' },
            { id: 4, name: 'Çaykara' },
            { id: 5, name: 'Maçka' },
            { id: 6, name: 'Of' },
            { id: 7, name: 'Ortahisar' },
            { id: 8, name: 'Sürmene' },
            { id: 9, name: 'Tonya' },
            { id: 10, name: 'Vakfıkebir' },
            { id: 11, name: 'Yomra' },
            { id: 12, name: 'Beşikdüzü' },
            { id: 13, name: 'Şalpazarı' },
            { id: 14, name: 'Çarşıbaşı' },
            { id: 15, name: 'Dernekpazarı' },
            { id: 16, name: 'Düzköy' },
            { id: 17, name: 'Hayrat' },
            { id: 18, name: 'Köprübaşı' }
          ]
        },
        {
          id: 62,
          name: 'Tunceli',
          district: [
            { id: 1, name: 'Çemişgezek' },
            { id: 2, name: 'Hozat' },
            { id: 3, name: 'Mazgirt' },
            { id: 4, name: 'Nazımiye' },
            { id: 5, name: 'Ovacık' },
            { id: 6, name: 'Pertek' },
            { id: 7, name: 'Pülümür' },
            { id: 8, name: 'Merkez' }
          ]
        },
        {
          id: 63,
          name: 'Şanlıurfa',
          district: [
            { id: 1, name: 'Akçakale' },
            { id: 2, name: 'Birecik' },
            { id: 3, name: 'Bozova' },
            { id: 4, name: 'Ceylanpınar' },
            { id: 5, name: 'Eyyübiye' },
            { id: 6, name: 'Halfeti' },
            { id: 7, name: 'Haliliye' },
            { id: 8, name: 'Hilvan' },
            { id: 9, name: 'Karaköprü' },
            { id: 10, name: 'Siverek' },
            { id: 11, name: 'Suruç' },
            { id: 12, name: 'Viranşehir' },
            { id: 13, name: 'Harran' }
          ]
        },
        {
          id: 64,
          name: 'Uşak',
          district: [
            { id: 1, name: 'Banaz' },
            { id: 2, name: 'Eşme' },
            { id: 3, name: 'Karahallı' },
            { id: 4, name: 'Sivaslı' },
            { id: 5, name: 'Ulubey' },
            { id: 6, name: 'Merkez' }
          ]
        },
        {
          id: 65,
          name: 'Van',
          district: [
            { id: 1, name: 'Başkale' },
            { id: 2, name: 'Çatak' },
            { id: 3, name: 'Erciş' },
            { id: 4, name: 'Gevaş' },
            { id: 5, name: 'Gürpınar' },
            { id: 6, name: 'İpekyolu' },
            { id: 7, name: 'Muradiye' },
            { id: 8, name: 'Özalp' },
            { id: 9, name: 'Tuşba' },
            { id: 10, name: 'Bahçesaray' },
            { id: 11, name: 'Çaldıran' },
            { id: 12, name: 'Edremit' },
            { id: 13, name: 'Saray' }
          ]
        },
        {
          id: 66,
          name: 'Yozgat',
          district: [
            { id: 1, name: 'Akdağmadeni' },
            { id: 2, name: 'Boğazlıyan' },
            { id: 3, name: 'Çayıralan' },
            { id: 4, name: 'Çekerek' },
            { id: 5, name: 'Sarıkaya' },
            { id: 6, name: 'Sorgun' },
            { id: 7, name: 'Şefaatli' },
            { id: 8, name: 'Yerköy' },
            { id: 9, name: 'Merkez' },
            { id: 10, name: 'Aydıncık' },
            { id: 11, name: 'Çandır' },
            { id: 12, name: 'Kadışehri' },
            { id: 13, name: 'Saraykent' },
            { id: 14, name: 'Yenifakılı' }
          ]
        },
        {
          id: 67,
          name: 'Zonguldak',
          district: [
            { id: 1, name: 'Çaycuma' },
            { id: 2, name: 'Devrek' },
            { id: 3, name: 'Ereğli' },
            { id: 4, name: 'Merkez' },
            { id: 5, name: 'Alaplı' },
            { id: 6, name: 'Gökçebey' }
          ]
        },
        {
          id: 68,
          name: 'Aksaray',
          district: [
            { id: 1, name: 'Ağaçören' },
            { id: 2, name: 'Eskil' },
            { id: 3, name: 'Gülağaç' },
            { id: 4, name: 'Güzelyurt' },
            { id: 5, name: 'Merkez' },
            { id: 6, name: 'Ortaköy' },
            { id: 7, name: 'Sarıyahşi' }
          ]
        },
        {
          id: 69,
          name: 'Bayburt',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Aydıntepe' },
            { id: 3, name: 'Demirözü' }
          ]
        },
        {
          id: 70,
          name: 'Karaman',
          district: [
            { id: 1, name: 'Ermenek' },
            { id: 2, name: 'Merkez' },
            { id: 3, name: 'Ayrancı' },
            { id: 4, name: 'Kazımkarabekir' },
            { id: 5, name: 'Başyayla' },
            { id: 6, name: 'Sarıveliler' }
          ]
        },
        {
          id: 71,
          name: 'Kırıkkale',
          district: [
            { id: 1, name: 'Delice' },
            { id: 2, name: 'Keskin' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Sulakyurt' },
            { id: 5, name: 'Bahşili' },
            { id: 6, name: 'Balışeyh' },
            { id: 7, name: 'Çelebi' },
            { id: 8, name: 'Karakeçili' },
            { id: 9, name: 'Yahşihan' }
          ]
        },
        {
          id: 72,
          name: 'Batman',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Beşiri' },
            { id: 3, name: 'Gercüş' },
            { id: 4, name: 'Kozluk' },
            { id: 5, name: 'Sason' },
            { id: 6, name: 'Hasankeyf' }
          ]
        },
        {
          id: 73,
          name: 'Şırnak',
          district: [
            { id: 1, name: 'Beytüşşebap' },
            { id: 2, name: 'Cizre' },
            { id: 3, name: 'İdil' },
            { id: 4, name: 'Silopi' },
            { id: 5, name: 'Merkez' },
            { id: 6, name: 'Uludere' },
            { id: 7, name: 'Güçlükonak' }
          ]
        },
        {
          id: 74,
          name: 'Bartın',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Kurucaşile' },
            { id: 3, name: 'Ulus' },
            { id: 4, name: 'Amasra' }
          ]
        },
        {
          id: 75,
          name: 'Ardahan',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Çıldır' },
            { id: 3, name: 'Göle' },
            { id: 4, name: 'Hanak' },
            { id: 5, name: 'Posof' },
            { id: 6, name: 'Damal' }
          ]
        },
        {
          id: 76,
          name: 'Iğdır',
          district: [
            { id: 1, name: 'Aralık' },
            { id: 2, name: 'Merkez' },
            { id: 3, name: 'Tuzluca' },
            { id: 4, name: 'Karakoyunlu' }
          ]
        },
        {
          id: 77,
          name: 'Yalova',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Altınova' },
            { id: 3, name: 'Armutlu' },
            { id: 4, name: 'Çınarcık' },
            { id: 5, name: 'Çiftlikköy' },
            { id: 6, name: 'Termal' }
          ]
        },
        {
          id: 78,
          name: 'Karabük',
          district: [
            { id: 1, name: 'Eflani' },
            { id: 2, name: 'Eskipazar' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Ovacık' },
            { id: 5, name: 'Safranbolu' },
            { id: 6, name: 'Yenice' }
          ]
        },
        {
          id: 79,
          name: 'Kilis',
          district: [
            { id: 1, name: 'Merkez' },
            { id: 2, name: 'Elbeyli' },
            { id: 3, name: 'Musabeyli' },
            { id: 4, name: 'Polateli' }
          ]
        },
        {
          id: 80,
          name: 'Osmaniye',
          district: [
            { id: 1, name: 'Bahçe' },
            { id: 2, name: 'Kadirli' },
            { id: 3, name: 'Merkez' },
            { id: 4, name: 'Düziçi' },
            { id: 5, name: 'Hasanbeyli' },
            { id: 6, name: 'Sumbas' },
            { id: 7, name: 'Toprakkale' }
          ]
        },
        {
          id: 81,
          name: 'Düzce',
          district: [
            { id: 1, name: 'Akçakoca' },
            { id: 2, name: 'Merkez' },
            { id: 3, name: 'Yığılca' },
            { id: 4, name: 'Cumayeri' },
            { id: 5, name: 'Gölyaka' },
            { id: 6, name: 'Çilimli' },
            { id: 7, name: 'Gümüşova' },
            { id: 8, name: 'Kaynaşlı' }
          ]
        }
      ]
    },
    changed: function (e) {
      this.$emit('input', e.target.value)

      return e.target.value
    }
  }
}
</script>